import {
  RELEVANT_CAPACITY_STATUSES_TO_DISPLAY_ACCEPTED_VOLUME,
  SUBMITTED_BID_STATUSES,
} from '@/features/bidding/constants'
import type { ExtendedBid } from '@/features/bidding/types/bid'
import type { BidHistory } from '@/features/bidding/types/bidHistory'

export function hasCapacityBidWithAcceptedStatusOnThisDay(
  bidHistories: BidHistory[],
  activationGroupUuid: string,
): boolean {
  const capacityBidOnThisDay = bidHistories.find((bidHistory) => bidHistory.activationGroupUuid === activationGroupUuid)

  return (
    capacityBidOnThisDay?.bids.some((bid) =>
      RELEVANT_CAPACITY_STATUSES_TO_DISPLAY_ACCEPTED_VOLUME.includes(bid.status),
    ) ?? false
  )
}

export function hasCapacityBidOnThisDay(bidHistories: BidHistory[], activationGroupUuid: string) {
  return bidHistories.find((bidHistory) => bidHistory.activationGroupUuid === activationGroupUuid)
}

export function getAcceptedCapacityBidOnThisDay(
  bidHistories: BidHistory[],
  activationGroupUuid: string,
): ExtendedBid | undefined {
  const capacityBidOnThisDay = bidHistories.find((bidHistory) => bidHistory.activationGroupUuid === activationGroupUuid)

  return capacityBidOnThisDay?.bids.findLast((bid) =>
    RELEVANT_CAPACITY_STATUSES_TO_DISPLAY_ACCEPTED_VOLUME.includes(bid.status),
  )
}

export function getLatestCapacityBidOnThisDay(
  bidHistories: BidHistory[],
  activationGroupUuid: string,
): ExtendedBid | undefined {
  const capacityBidOnThisDay = bidHistories.find((bidHistory) => bidHistory.activationGroupUuid === activationGroupUuid)

  return capacityBidOnThisDay?.bids
    .filter((bid) => SUBMITTED_BID_STATUSES.includes(bid.status))
    .toSorted((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf())[0]
}
